import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { updateCacheByType } from './GraphQlProvider';
import { WcvLog } from './logs.datatypes';
import {StatusMessage} from './common.datatypes';

export interface AddLogVars {
  data: {
    user_id: number | null,
    level: number
    type: number
    type_id: number | null
    code: string
    description: string
    payload: string
  };
}

interface AddLogData {
  addLog: StatusMessage
}

export const ADD_LOG_MUTATION = gql`
    mutation addLog($data: AddLogInput!) {
        addLog(data: $data) {
          status
          message
        }
    }
`;

export const addLog = (refreshCache: boolean = true) => useMutation<AddLogData, AddLogVars>(
  ADD_LOG_MUTATION,
  {
    update: refreshCache ? updateCacheByType('WcvLog') : undefined,
  }
);

export default addLog;